export default "__VITE_ASSET__507aed8d__"